export const OFFER_LIKE = "OFFER__LIKE"
export const OFFER_UNLIKE = "OFFER__UNLIKE"
export const ARTICLE_LIKE = "ARTICLE__LIKE"
export const ARTICLE_UNLIKE = "ARTICLE__UNLIKE"
